<template>
  <v-container fluid class="login-container">

    <view-card-template>
        <template #viewHeader>
            <view-app-bar></view-app-bar>
        </template> <template #cardTitle>
            <span class="logo">Contact Us</span>
        </template>
        <template #cardBody>
      <v-form @submit.prevent="submitForm">
        <v-row no-gutters
            class="mt-2 mb-4 row align-center">
          <v-col sm="5">
            <v-text-field
            class="mx-4" 
              v-model="name"
              label="Name"
              required
            ></v-text-field>
          </v-col>
          <v-col sm="2"></v-col>
          <v-col sm="5">
            <v-text-field
              class="mx-4"
            :class="{ 'invalid-email': !bolEmail }"
              v-model="email"
              label="Email"
              required
              type="email"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters
            class="mt-2 mb-4 row align-center">
          <v-col sm="8">
            <v-select 
              label="Please Select" 
              class="mx-4" 
              :items="dropDown"
              v-model="currentSelection"
              @input="updateBoolean(currentSelection)"
              required></v-select>
          </v-col>
        </v-row>
      <v-textarea
        class="mx-4 custom-textarea"
        v-model="message"
        label="Message"
        rows="5"
        :counter="500"
        :rules="messageRules"
        required
      ></v-textarea>

      <v-btn type="submit" color="primary">Submit</v-btn>
    </v-form>
  </template>
    </view-card-template>
    <view-footer></view-footer>
  </v-container>
</template>

<script>
import ViewCardTemplate from '../components/templates/ViewCardTemplate.vue';
import ViewAppBar from '../components/templates/ViewAppBar.vue';
import ViewFooter from '../components/templates/ViewFooter.vue';
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'contact-us',
  components: {
    ViewCardTemplate,
    ViewAppBar,
    ViewFooter
  },
  data() {
    return {
      name: '',
      email: '',
      message: '',
      messageRules: [v => v.length <= 500 || 'Character limit exceeded (500 characters)'],
      characterCount: 0,
      subject: 'Feedback',
      currentSelection: '',
      modalString: '',
      bolName: true,
      bolMessage: true,
      bolEmail: true,
      bolCurrentSelection: true,
    dropDown: [
      'Access Issues',
      'Technical Issues',
      'Feedback',
      'Other',
    ],
    
    };
  },
  watch: {
    message() {
      this.characterCount = this.message.length; // Update characterCount whenever message changes
    },
  },
  methods: {
    updateBoolean(event) {
      this.currentSelection = event
      this.subject = event
    },
    async isEmailValid(email) {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return email.match(emailPattern) !== null;
    },
    async submitForm() {
      let arrWrong = []
      if(!this.name) this.bolName = false, arrWrong.push('Name')
      if(!this.message ||this.characterCount > 500) this.bolMessage = false, arrWrong.push('Message')
      if(!this.currentSelection) this.bolCurrentSelection = false,arrWrong.push('Subject')
      if(this.email) {
        const validEmail = await this.isEmailValid(this.email)
        if(!validEmail) this.bolEmail = false, arrWrong.push('Email')
      } else this.bolEmail = false, arrWrong.push('Email')
      if (!this.bolName || !this.bolEmail|| !this.bolCurrentSelection || !this.bolMessage) {
        this.modalString = `Please make sure the following required fields are included in the submit request and meet the acceptable criteria: ${arrWrong}`
        this.showModal(this.modalString, 'Form Error');
        arrWrong = []
        this.bolName = true
        this.bolEmail = true
        this.bolCurrentSelection = true
        this. bolMessage = true
        return
      }
      var data = JSON.stringify({
        "name": this.name,
        "email": this.email,
        "subject": this.subject,
        "message": this.message
      });

      var config = {
        method: 'post',
        url: process.env.VUE_APP_API_JIRA_URL,
        headers: { 
          'x-api-key': process.env.VUE_APP_API_ARCHIVE_KEY, 
          'Content-Type': 'application/json'
        },
        data : data
      };
      const response = await axios(config);
      this.modalString = `Thank you for contacting us. ${response.data.ticketId} has been created. \n A member of our team will review your request and respond soon.`
      this.showModal(this.modalString, 'Request Submitted');
      this.$router.push('/Home');
    },
    showModal(strText, strTitle) {
      this.$store.commit('toggleDialog', { show: true, text: strText, titleText: strTitle });
    },
  },
  computed: {
    ...mapState(['user']),
  }
};
</script>
<style>
.login-container {
   background-image: url("~@/assets/background.png"); /* Replace with the path to your PNG image */
   background-size: cover;
   background-position: center;
   min-height: 100vh;
 }
 .logo {
    font-style: italic;
    color: black;
    font-weight: 800;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 24pt;
}
.custom-textarea textarea {
  border: 1px solid #ccc; /* Add your desired border styles here */
  border-radius: 4px;
  padding: 8px;
}
.invalid-input {
  border: 1px solid red;
}
</style>
